// extracted by mini-css-extract-plugin
export default {"section":"ArtistsSection_section__++k0O","title":"ArtistsSection_title__DL4gO"};